import React, {useContext, useState} from 'react'
import {Navigate} from 'react-router'

import AuthContext from '../contexts/AuthContext'
import AuthAPI from '../services/AuthAPI'
import {ROOT_PATH} from '../constants/RoutesPaths'

interface AdminRouteInterface {
  component: React.ElementType;
}

const AdminRoute = ({component: Component}: AdminRouteInterface) => {
  const {isAuthenticated, user} = useContext(AuthContext)
  const [isAdmin, setIsAdmin] = useState(AuthAPI.isAdministrator(user))

  return (
    (isAuthenticated && isAdmin && <Component />) || <Navigate to={ROOT_PATH} />
  )
}

export default AdminRoute
